<div class="header">
  <div class="title">
    Error
  </div>
  <div class="message">
    {{ errorMessage }}
  </div>
</div>
